import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL } from '../BaseURL';

export const customerQuickAddV2 = (storeId, data) => {
    return axios({
      method: 'post',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v2/store/' +
        storeId +
        '/store-customer/quick-add', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const customerInternationalNumberAdd = (storeId, data) => {
    return axios({
      method: 'post',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v2/store/' +
        storeId +
        '/store-customer', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };